import { Drawer } from 'antd';
import React, { useEffect, useState } from 'react';
import { drawerStyles } from '../../../config/styles/theme';
import './style.scss';

type AppDrawerProps = {
  title: React.ReactNode;
  isOpen: boolean;
  children: React.ReactNode;
  onClose: () => void;
  icon?: React.ReactNode;
  width?: number;
  footer?: React.ReactNode;
};

const AppDrawer: React.FC<AppDrawerProps> = ({ title, isOpen, children, onClose, icon, width = 720, footer = null }) => {
  const [isOpenDrawer, setIsOpenDrawer] = useState(isOpen);
  const handleDrawerTitle = (): React.ReactNode => (
    <div className='drawer-title-container'>
      {icon && <div className='icon'>{icon}</div>}
      {title}
    </div>
  );

  useEffect(() => {
    setIsOpenDrawer(isOpen);
  }, [isOpen]);

  return (
    <Drawer
      title={handleDrawerTitle()}
      width={width}
      onClose={onClose}
      open={isOpenDrawer}
      className='app-drawer'
      destroyOnClose
      footer={footer}
      styles={drawerStyles}
    >
      {children}
    </Drawer>
  );
};

export default AppDrawer;
